module.exports = __webpack_public_path__ + "lt.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/lt.svg
// module id = 667
// module chunks = 0